import React, { useState, useEffect } from "react";
// import './Header.css'
// import "../Header/Header.css"
import logout from "../../../assets/new-images/logout.png";
import { showSuccessToast } from "../../../assets/toastUtils";
import { Link, NavLink, useNavigate, useParams } from "react-router-dom";
import { getContentScore } from "../../../utils/utils";
import ActivePropertySelectBox from "../ActivePropertySelectBox/ActivePropertySelectBox";
import LoginBtn from "../../Login/LoginBtn";
import VendorAccountDetailDropdown from "./VendorAccountDetailDropdown";
import logoimg from "../../../assets/images/Mountain-mystries-logo.png";
import { getDecryptedData } from "../../../utils/crypto";

function VendorHeader({ showSelectProperty, vendorProperty }) {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loader, setLoader] = useState(false);
  const [hideToggle, setHideToggle] = useState(false);
  const [logOutPopup, setLogOutPopup] = useState(false);
  const navigate = useNavigate();
  const handleShowToggle = () => {
    setHideToggle(!hideToggle);
  };
  const [accountDetails, setAccountDetails] = useState(false);

  const vendorToken = getDecryptedData("userToken");

  const handleOnClick = (e) => {
    e.preventDefault();
    setAccountDetails(!accountDetails);
  };
  const [loginDetails, setLoginDetails] = useState(false);
  const handleOnClickLogIn = (e) => {
    e.preventDefault();
    setLoginDetails(!loginDetails);
  };

  // console.log("isLoggedIn", isLoggedIn);
  useEffect(() => {
    // Check if token is present in local storage
    const token = localStorage.getItem("token");
    if (token) {
      setIsLoggedIn(true);
    } else {
      setIsLoggedIn(false);
    }
  }, []);

  const handleLogout = async (e) => {
    e.preventDefault();

    navigate("/");
    localStorage.clear();
    showSuccessToast("Logged Out Successful");
  };
  const customButtonStyles = {
    fontSize: "12px",
    fontWeight: "500",
  };

  const [customerData, setCustomerData] = useState([]);
  const [agentData, setAgentData] = useState([]);

  const [name, setName] = useState("");
  const [userType, setUserType] = useState("");

  useEffect(() => {
    const storedUserDetails = localStorage.getItem("userDetails");
    // console.log(storedUserDetails);
    if (storedUserDetails) {
      const userDetails = JSON.parse(storedUserDetails);
      // console.log(userDetails);
      setName(userDetails.Name);
    }

    const storedUserType = localStorage.getItem("userType");
    if (storedUserType) {
      setUserType(storedUserType);
    }
  }, []);
  const closePriceDetails = (id) => {
    setHideToggle(false);
  };

  const { id } = useParams();
  // console.log(id);
  const [dropdown, setDropdown] = useState(false);

  const handleOpenDropdown = () => {
    setDropdown((prevState) => !prevState);
  };

  const [formData, setFormData] = useState({
    company_name: "",
    phone: "",
    email: "",
    country: "",
    state: "",
    city: "",
    address: "",
    agent_category: "",
    company_gst_information: "",
    company_pan_information: "",
    company_tan_information: "",
    zipcode: "",
  });

  const [addressData, setAddressData] = useState({
    country: "",
    state: "",
    city: "",
    address: "",
    latitude: "",
    longitude: "",
    placeId: "",
  });

  const fetchVendorDetails = () => {
    fetch(
      `${process.env.REACT_APP_BASE_URL}/api/v1/website/supplier/user-profile`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${vendorToken}`,
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
          let additionalDetails;

          if (Array.isArray(data?.data?.additional_details)) {
            additionalDetails = {
              company_gst: data?.data?.additional_details[0]?.gst,
              company: data?.data?.additional_details[0]?.company,
              company_tan: data?.data?.additional_details[0]?.company_tan,
              contact_person: data?.data?.additional_details[0]?.contact_person,
              contact_person_email:
                data?.data?.additional_details[0]?.contact_person_email,
              contact_person_number:
                data?.data?.additional_details[0]?.contact_person_number,
            };
          } else {
            additionalDetails = {
              company_gst: data?.data?.additional_details?.gst,
              company: data?.data?.additional_details?.company,
              company_tan: data?.data?.additional_details?.company_tan,
              contact_person: data?.data?.additional_details?.contact_person,
              contact_person_email:
                data?.data?.additional_details?.contact_person_email,
              contact_person_number:
                data?.data?.additional_details?.contact_person_number,
            };
          }

          setFormData({
            name: data?.data?.name || "",
            phone: data?.data?.phone || "",
            email: data?.data?.email || "",
            country: data?.data?.country || "",
            state: data?.data?.state || "",
            city: data?.data?.city || "",
            address: data?.data?.address || "",
            zipcode: data?.data.zipcode || "",
            company_gst_information: additionalDetails?.company_gst || "",
            company_information: additionalDetails?.company || "",
            // company_tan_information: additionalDetails?.company_tan || "",
          });
          setAddressData({
            country: data?.data?.country || "",
            state: data?.data?.state || "",
            city: data?.data?.city || "",
            address: data?.data?.address || "",
            latitude: data?.data?.latitude || "",
            longitude: data?.data?.longitude || "",
            placeId: data?.data?.placeId || "",
          });

          // console.log();
        } else {
        }
      })
      .catch((error) => {
        console.error("Error fetching agent details:", error);
      });
  };

  useEffect(() => {
    fetchVendorDetails();
  }, []);

  const arrayToCheck = [
    "name",
    "email",
    "phone",
    "city",
    "state",
    "country",
    "address",
    "zipcode",
    "company_gst_information",
    "company_information",
    // "company_pan_information",
    // "contact_person_information",
    // "contact_person_email_information",
  ];

  const score = getContentScore({
    formData: formData,
    arrayToCheck,
  });

  return (
    <header style={{ padding: "10px", borderRadius: "15px" }}>
      <button
        className="toggle_menu_icon agent_newtogglee_menu_icon"
        onClick={handleShowToggle}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="30"
          height="22"
          viewBox="0 0 30 22"
          fill="none"
          style={{ margin: "0" }}
        >
          <rect y="0.399902" width="30" height="1.2" fill="#333333"></rect>
          <rect y="10.3999" width="30" height="1.2" fill="#333333"></rect>
          <rect y="20.3999" width="30" height="1.2" fill="#333333"></rect>
        </svg>
      </button>
      {hideToggle && (
        <div className="fixed_bg_navbar">
          <div className="" id="vendorProperty">
            <div className="sidebar newUI_mobile_sidebar" id="sidebar">
              <div className="close_popup">
                <svg
                  onClick={() => setHideToggle(false)}
                  width="30"
                  height="30"
                  viewBox="0 0 14 13"
                  style={{ margin: "5px" }}
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M1 12.5L13 0.5" stroke="#000000" strokeWidth="1.2" />
                  <path d="M13 12.5L1 0.5" stroke="#000000" strokeWidth="1.2" />
                </svg>
              </div>{" "}
              {showSelectProperty && (
                <div style={{ padding: "10px" }}>
                  <ActivePropertySelectBox />
                </div>
              )}
              <div>
                <NavLink className="Header-icon" to="/" exact>
                  <img
                    src={logoimg}
                    alt="logo-image"
                    className="logo"
                    style={{ marginLeft: "10px" }}
                  />
                </NavLink>
                {/* <small className="small_text">MENU</small> */}
                <NavLink
                  className="sidebar_btn flex align_items_center flex_gap_5"
                  to={`/partner/overview/${id}`}
                >
                  <span className="active_bg_color"></span>
                  <span className="sidebar_btn_icon_text">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="21"
                      viewBox="0 0 20 21"
                      fill="none"
                    >
                      <mask
                        id="mask0_6855_8514"
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="20"
                        height="21"
                      >
                        <rect y="0.5" width="20" height="20" fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_6855_8514)">
                        <path
                          d="M4.42443 17.5833C4.00345 17.5833 3.64714 17.4375 3.35547 17.1458C3.0638 16.8542 2.91797 16.4978 2.91797 16.0769V4.92311C2.91797 4.50214 3.0638 4.14582 3.35547 3.85416C3.64714 3.56249 4.00345 3.41666 4.42443 3.41666H15.5782C15.9992 3.41666 16.3555 3.56249 16.6471 3.85416C16.9388 4.14582 17.0846 4.50214 17.0846 4.92311V16.0769C17.0846 16.4978 16.9388 16.8542 16.6471 17.1458C16.3555 17.4375 15.9992 17.5833 15.5782 17.5833H4.42443ZM4.42443 16.3333H9.3763V4.66666H4.42443C4.36026 4.66666 4.30151 4.69339 4.24818 4.74686C4.19471 4.8002 4.16797 4.85895 4.16797 4.92311V16.0769C4.16797 16.141 4.19471 16.1998 4.24818 16.2531C4.30151 16.3066 4.36026 16.3333 4.42443 16.3333ZM10.6263 16.3333H15.5782C15.6423 16.3333 15.7011 16.3066 15.7544 16.2531C15.8079 16.1998 15.8346 16.141 15.8346 16.0769V10.5H10.6263V16.3333ZM10.6263 9.24999H15.8346V4.92311C15.8346 4.85895 15.8079 4.8002 15.7544 4.74686C15.7011 4.69339 15.6423 4.66666 15.5782 4.66666H10.6263V9.24999Z"
                          fill="#888888"
                        />
                      </g>
                    </svg>
                    Dashboard
                  </span>
                </NavLink>
                {/* <NavLink
                          className="sidebar_btn flex align_items_center flex_gap_5"
                          to={`/partner/all-rooms/${id}`}
                        >
                          <span className="active_bg_color"></span>
                          <span className="sidebar_btn_icon_text">
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <mask
                                id="mask0_4521_3526"
                                style={{ maskType: "alpha" }}
                                maskUnits="userSpaceOnUse"
                                x="0"
                                y="0"
                                width="24"
                                height="24"
                              >
                                <rect width="24" height="24" fill="#888888" />
                              </mask>
                              <g mask="url(#mask0_4521_3526)">
                                <path
                                  d="M7 19H6L5.35 17H4V11.975C4 11.425 4.19583 10.9583 4.5875 10.575C4.97917 10.1917 5.45 10 6 10V7C6 6.45 6.19583 5.97917 6.5875 5.5875C6.97917 5.19583 7.45 5 8 5H16C16.55 5 17.0208 5.19583 17.4125 5.5875C17.8042 5.97917 18 6.45 18 7V10C18.55 10 19.0208 10.1958 19.4125 10.5875C19.8042 10.9792 20 11.45 20 12V17H18.65L18 19H17L16.35 17H7.65L7 19ZM13 10H16V7H13V10ZM8 10H11V7H8V10ZM6 15H18V12H6V15Z"
                                  fill="#888888"
                                />
                              </g>
                            </svg>
                            Rooms
                          </span>
                        </NavLink> */}
                {/* <NavLink
                  className="sidebar_btn flex align_items_center  flex_gap_5"
                  to={`/partner/all-room-rates/${id}`}
                >
                  <span className="active_bg_color"></span>
                  <span className="sidebar_btn_icon_text">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <mask
                        id="mask0_4521_3532"
                        style={{ maskType: "alpha" }}
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="24"
                        height="24"
                      >
                        <rect width="24" height="24" fill="#888888" />
                      </mask>
                      <g mask="url(#mask0_4521_3532)">
                        <path
                          d="M13.725 21L7 14V12H10.5C11.3833 12 12.1458 11.7125 12.7875 11.1375C13.4292 10.5625 13.8167 9.85 13.95 9H6V7H13.65C13.3667 6.41667 12.9458 5.9375 12.3875 5.5625C11.8292 5.1875 11.2 5 10.5 5H6V3H18V5H14.75C14.9833 5.28333 15.1917 5.59167 15.375 5.925C15.5583 6.25833 15.7 6.61667 15.8 7H18V9H15.975C15.8417 10.4167 15.2583 11.6042 14.225 12.5625C13.1917 13.5208 11.95 14 10.5 14H9.775L16.5 21H13.725Z"
                          fill="#888888"
                        />
                      </g>
                    </svg>
                    Rate Plans
                  </span>
                </NavLink> */}
                {/* <NavLink
                  className="sidebar_btn flex align_items_center  flex_gap_5"
                  to={`/vendor/property/list`}
                >
                  <span className="active_bg_color"></span>
                  <span className="sidebar_btn_icon_text">
                    <svg
                      width="20"
                      height="21"
                      viewBox="0 0 20 21"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <mask
                        id="mask0_7193_3298"
                        style={{ maskType: "alpha" }}
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="20"
                        height="21"
                      >
                        <rect y="0.5" width="20" height="20" fill="#888888" />
                      </mask>
                      <g mask="url(#mask0_7193_3298)">
                        <path
                          d="M3.23849 17.6475C2.8871 17.6475 2.58828 17.5244 2.34203 17.2782C2.09578 17.0318 1.97266 16.7329 1.97266 16.3815V4.33004C1.97266 3.97865 2.09578 3.67983 2.34203 3.43358C2.58828 3.18733 2.8871 3.06421 3.23849 3.06421H8.62328C8.97467 3.06421 9.27349 3.18733 9.51974 3.43358C9.76599 3.67983 9.88911 3.97865 9.88911 4.33004V6.39754H16.7643C17.1157 6.39754 17.4145 6.52067 17.6608 6.76692C17.907 7.01317 18.0302 7.31199 18.0302 7.66338V16.3815C18.0302 16.7329 17.907 17.0318 17.6608 17.2782C17.4145 17.5244 17.1157 17.6475 16.7643 17.6475H3.23849ZM3.22245 16.3975H8.63932V14.3142H3.22245V16.3975ZM3.22245 13.0642H8.63932V10.9809H3.22245V13.0642ZM3.22245 9.73088H8.63932V7.64754H3.22245V9.73088ZM3.22245 6.39754H8.63932V4.31421H3.22245V6.39754ZM9.88911 16.3975H16.7804V7.64754H9.88911V16.3975ZM12.3412 10.9809C12.1641 10.9809 12.0156 10.9209 11.8958 10.8011C11.7761 10.6812 11.7162 10.5327 11.7162 10.3555C11.7162 10.1784 11.7761 10.03 11.8958 9.91025C12.0156 9.79067 12.1641 9.73088 12.3412 9.73088H14.1681C14.3452 9.73088 14.4936 9.79081 14.6133 9.91067C14.7331 10.0304 14.7931 10.1789 14.7931 10.3561C14.7931 10.5333 14.7331 10.6817 14.6133 10.8013C14.4936 10.921 14.3452 10.9809 14.1681 10.9809H12.3412ZM12.3412 14.3142C12.1641 14.3142 12.0156 14.2543 11.8958 14.1344C11.7761 14.0146 11.7162 13.866 11.7162 13.6888C11.7162 13.5117 11.7761 13.3633 11.8958 13.2436C12.0156 13.124 12.1641 13.0642 12.3412 13.0642H14.1681C14.3452 13.0642 14.4936 13.1241 14.6133 13.244C14.7331 13.3637 14.7931 13.5122 14.7931 13.6894C14.7931 13.8666 14.7331 14.015 14.6133 14.1346C14.4936 14.2543 14.3452 14.3142 14.1681 14.3142H12.3412Z"
                          fill="#888888"
                        />
                      </g>
                    </svg>
                    Properties
                  </span>
                </NavLink> */}
                <NavLink
                  className="sidebar_btn flex align_items_center flex_gap_5"
                  to={`/partner/bookings/${id}`}
                >
                  <span className="active_bg_color"></span>
                  <span className="sidebar_btn_icon_text">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <mask
                        id="mask0_4518_3506"
                        style={{ maskType: "alpha" }}
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="24"
                        height="24"
                      >
                        <rect width="24" height="24" fill="#888888" />
                      </mask>
                      <g mask="url(#mask0_4518_3506)">
                        <path
                          d="M11.0667 15.105L14.1556 11.9775C14.3333 11.7975 14.5481 11.7075 14.8 11.7075C15.0519 11.7075 15.2667 11.7975 15.4444 11.9775C15.6222 12.1575 15.7111 12.375 15.7111 12.63C15.7111 12.885 15.6222 13.1025 15.4444 13.2825L11.6889 17.085C11.5111 17.265 11.3037 17.355 11.0667 17.355C10.8296 17.355 10.6222 17.265 10.4444 17.085L8.55556 15.1725C8.37778 14.9925 8.28889 14.775 8.28889 14.52C8.28889 14.265 8.37778 14.0475 8.55556 13.8675C8.73333 13.6875 8.94815 13.5975 9.2 13.5975C9.45185 13.5975 9.66667 13.6875 9.84444 13.8675L11.0667 15.105ZM5.77778 21C5.28889 21 4.87037 20.8237 4.52222 20.4713C4.17407 20.1187 4 19.695 4 19.2V6.6C4 6.105 4.17407 5.68125 4.52222 5.32875C4.87037 4.97625 5.28889 4.8 5.77778 4.8H6.66667V3.9C6.66667 3.645 6.75185 3.43125 6.92222 3.25875C7.09259 3.08625 7.3037 3 7.55556 3C7.80741 3 8.01852 3.08625 8.18889 3.25875C8.35926 3.43125 8.44444 3.645 8.44444 3.9V4.8H15.5556V3.9C15.5556 3.645 15.6407 3.43125 15.8111 3.25875C15.9815 3.08625 16.1926 3 16.4444 3C16.6963 3 16.9074 3.08625 17.0778 3.25875C17.2481 3.43125 17.3333 3.645 17.3333 3.9V4.8H18.2222C18.7111 4.8 19.1296 4.97625 19.4778 5.32875C19.8259 5.68125 20 6.105 20 6.6V19.2C20 19.695 19.8259 20.1187 19.4778 20.4713C19.1296 20.8237 18.7111 21 18.2222 21H5.77778ZM5.77778 19.2H18.2222V10.2H5.77778V19.2ZM5.77778 8.4H18.2222V6.6H5.77778V8.4Z"
                          fill="#888888"
                        />
                      </g>
                    </svg>
                    Bookings
                  </span>
                </NavLink>

                <NavLink
                  className="sidebar_btn flex align_items_center flex_gap_5"
                  to={`/vendor/property/edit/${id}`}
                >
                  <span className="active_bg_color"></span>
                  <span className="sidebar_btn_icon_text">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="20"
                      viewBox="0 -960 960 960"
                      width="20"
                      fill="#888888"
                    >
                      <path d="M560-440h200v-80H560v80Zm0-120h200v-80H560v80ZM200-320h320v-22q0-45-44-71.5T360-440q-72 0-116 26.5T200-342v22Zm160-160q33 0 56.5-23.5T440-560q0-33-23.5-56.5T360-640q-33 0-56.5 23.5T280-560q0 33 23.5 56.5T360-480ZM160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm0-80h640v-480H160v480Zm0 0v-480 480Z" />
                    </svg>
                    General Details
                  </span>
                </NavLink>

                <NavLink
                  className="sidebar_btn flex align_items_center flex_gap_5"
                  to={`/vendor/property/all-rooms/${id}`}
                >
                  <span className="active_bg_color"></span>
                  <span className="sidebar_btn_icon_text">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="20"
                      viewBox="0 -960 960 960"
                      width="20"
                      fill="#888888"
                    >
                      <path d="M300-240h-24l-36-96h-48v-192q0-30.08 21.15-51.04T264-600v-96q0-29.7 21.17-50.85Q306.33-768 336.06-768h288.22Q654-768 675-746.85T696-696v96q30 0 51 21.15T768-528v192h-48l-36 96h-24l-36-96H336l-36 96Zm216-360h108v-96H516v96Zm-180 0h108v-96H336v96Zm-72 192h432v-120H264v120Zm432 0H264h432Z" />
                    </svg>
                    Rooms
                  </span>
                </NavLink>

                <NavLink
                  className="sidebar_btn flex align_items_center flex_gap_5"
                  to={`/vendor/property/inventory/${id}`}
                >
                  <span className="active_bg_color"></span>
                  <span className="sidebar_btn_icon_text">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="20"
                      viewBox="0 -960 960 960"
                      width="20"
                      fill="#888888"
                    >
                      <path d="M616-192 447-362l51-51 118 119 221-221 51 51-272 272Zm200-384h-72v-168h-72v120H288v-120h-72v528h216v72H216q-29.7 0-50.85-21.15Q144-186.3 144-216v-528q0-29.7 21.15-50.85Q186.3-816 216-816h171q8-31 33.5-51.5T480-888q34 0 59.5 20.5T573-816h171q29.7 0 50.85 21.15Q816-773.7 816-744v168ZM479.79-744q15.21 0 25.71-10.29t10.5-25.5q0-15.21-10.29-25.71t-25.5-10.5q-15.21 0-25.71 10.29t-10.5 25.5q0 15.21 10.29 25.71t25.5 10.5Z" />
                    </svg>
                    Inventory
                  </span>
                </NavLink>

                <NavLink
                  className="sidebar_btn flex align_items_center flex_gap_5"
                  to={`/vendor/property/rates/${id}`}
                >
                  <span className="active_bg_color"></span>
                  <span className="sidebar_btn_icon_text">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="20"
                      viewBox="0 -960 960 960"
                      width="20"
                      fill="#888888"
                    >
                      <path d="M547-144 288-408v-72h132q50 0 89-35.5t43-84.5H264v-72h274q-19-35-49.5-53.5T420-744H264v-72h432v72H576q13 17 23.5 33.5T615-672h81v72h-72q-5 81-64 136.5T420-408h-31l259 264H547Z" />
                    </svg>
                    Rates
                  </span>
                </NavLink>

                <NavLink
                  className="sidebar_btn flex align_items_center flex_gap_5"
                  to={`/vendor/property/rules/${id}`}
                >
                  <span className="active_bg_color"></span>
                  <span className="sidebar_btn_icon_text">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="20"
                      viewBox="0 -960 960 960"
                      width="20"
                      fill="#888888"
                    >
                      <path d="M480-96q-136-38-212-160t-76-259v-229l288-120 288 120v229q0 72-22 147t-71 134L553.14-356Q536-345 518-340.5t-38 4.5q-60 0-102-42t-42-102q0-60 42-102t102-42q60 0 102 42t42 102q0 20-5 38.11T604-407l55 55q17-39 27-80t10-83v-181l-216-90-216 90v181q0 105 56.5 203.5T480-171q28-9 51.5-25t44.5-36l51 52q-32 29-68.5 51T480-96Zm.21-312Q510-408 531-429.21t21-51Q552-510 530.79-531t-51-21Q450-552 429-530.79t-21 51Q408-450 429.21-429t51 21Zm-.21-72Z" />
                    </svg>
                    Policies
                  </span>
                </NavLink>

                {/* <div
                          className="sidebar_btn flex align_items_center flex_gap_5"
                          style={{marginLeft:"10px"}}
                          onClick={() => handleOpenDropdown()}
                        >
                          <Link className="sidebar_btn flex align_items_center">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <mask
                                id="mask0_4518_3502"
                                style={{ maskType: "alpha" }}
                                maskUnits="userSpaceOnUse"
                                x="0"
                                y="0"
                                width="24"
                                height="24"
                              >
                                <rect width="24" height="24" fill="#888888" />
                              </mask>
                              <g mask="url(#mask0_4518_3502)">
                                <path
                                  d="M7.95 15.15H16.05V15.825C16.05 16.02 16.1138 16.1812 16.2413 16.3088C16.3688 16.4362 16.53 16.5 16.725 16.5C16.92 16.5 17.0813 16.4362 17.2087 16.3088C17.3363 16.1812 17.4 16.02 17.4 15.825V12.765C17.4 12.315 17.2762 11.9137 17.0288 11.5612C16.7812 11.2087 16.455 10.95 16.05 10.785V9.3C16.05 8.805 15.8737 8.38125 15.5212 8.02875C15.1687 7.67625 14.745 7.5 14.25 7.5H9.75C9.255 7.5 8.83125 7.67625 8.47875 8.02875C8.12625 8.38125 7.95 8.805 7.95 9.3V10.785C7.545 10.95 7.21875 11.2087 6.97125 11.5612C6.72375 11.9137 6.6 12.315 6.6 12.765V15.825C6.6 16.02 6.66375 16.1812 6.79125 16.3088C6.91875 16.4362 7.08 16.5 7.275 16.5C7.47 16.5 7.63125 16.4362 7.75875 16.3088C7.88625 16.1812 7.95 16.02 7.95 15.825V15.15ZM7.95 13.8V12.765C7.95 12.555 8.025 12.375 8.175 12.225C8.325 12.075 8.505 12 8.715 12H15.285C15.495 12 15.675 12.075 15.825 12.225C15.975 12.375 16.05 12.555 16.05 12.765V13.8H7.95ZM9.3 10.65V8.85H14.7V10.65H9.3ZM4.8 21C4.305 21 3.88125 20.8237 3.52875 20.4713C3.17625 20.1187 3 19.695 3 19.2V4.8C3 4.305 3.17625 3.88125 3.52875 3.52875C3.88125 3.17625 4.305 3 4.8 3H19.2C19.695 3 20.1187 3.17625 20.4713 3.52875C20.8237 3.88125 21 4.305 21 4.8V19.2C21 19.695 20.8237 20.1187 20.4713 20.4713C20.1187 20.8237 19.695 21 19.2 21H4.8ZM4.8 19.2H19.2V4.8H4.8V19.2Z"
                                  fill="#888888"
                                />
                              </g>
                            </svg>
                            Rates & Inventory{" "}
                            <svg
                              style={{ marginLeft: "10px" }}
                              width="10"
                              height="7"
                              viewBox="0 0 12 7"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              className={dropdown ? "rotate-icon" : ""}
                            >
                              <path
                                d="M11 0.5L6 5.5L1 0.5"
                                stroke="#333333"
                                strokeWidth="1.2"
                              />
                            </svg>
                          </Link>
                        </div>
                        {dropdown && (
                          <div
                            className="flex flex_direction_col flex_gap_10"
                            style={{ paddingLeft: "35px" }}
                          >
                            <span className="active_bg_color"></span>{" "}
                            <NavLink className="" to={`/partner/rates/${id}`} style={{color:"#888888"}}>
                              Rates
                            </NavLink>
                            <NavLink
                              className="mb-10"
                              to={`/partner/inventory/${id}`} style={{color:"#888888"}}
                            >
                              Inventory
                            </NavLink>
                          </div>
                        )} */}
                {/* <NavLink
                          className="sidebar_btn flex align_items_center flex_gap_5"
                          to={`/partner/promotion/${id}`}
                        >
                          <span className="active_bg_color"></span>
                          <span className="sidebar_btn_icon_text">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <mask
                                id="mask0_4518_3510"
                                style={{ maskType: "alpha" }}
                                maskUnits="userSpaceOnUse"
                                x="0"
                                y="0"
                                width="24"
                                height="24"
                              >
                                <rect width="24" height="24" fill="#888888" />
                              </mask>
                              <g mask="url(#mask0_4518_3510)">
                                <path
                                  d="M7.50006 11C6.53339 11 5.70839 10.6583 5.02506 9.975C4.34173 9.29167 4.00006 8.46667 4.00006 7.5C4.00006 6.53333 4.34173 5.70833 5.02506 5.025C5.70839 4.34167 6.53339 4 7.50006 4C8.46673 4 9.29173 4.34167 9.97506 5.025C10.6584 5.70833 11.0001 6.53333 11.0001 7.5C11.0001 8.46667 10.6584 9.29167 9.97506 9.975C9.29173 10.6583 8.46673 11 7.50006 11ZM7.50006 9C7.91673 9 8.27089 8.85417 8.56256 8.5625C8.85423 8.27083 9.00006 7.91667 9.00006 7.5C9.00006 7.08333 8.85423 6.72917 8.56256 6.4375C8.27089 6.14583 7.91673 6 7.50006 6C7.08339 6 6.72923 6.14583 6.43756 6.4375C6.14589 6.72917 6.00006 7.08333 6.00006 7.5C6.00006 7.91667 6.14589 8.27083 6.43756 8.5625C6.72923 8.85417 7.08339 9 7.50006 9ZM16.5001 20C15.5334 20 14.7084 19.6583 14.0251 18.975C13.3417 18.2917 13.0001 17.4667 13.0001 16.5C13.0001 15.5333 13.3417 14.7083 14.0251 14.025C14.7084 13.3417 15.5334 13 16.5001 13C17.4667 13 18.2917 13.3417 18.9751 14.025C19.6584 14.7083 20.0001 15.5333 20.0001 16.5C20.0001 17.4667 19.6584 18.2917 18.9751 18.975C18.2917 19.6583 17.4667 20 16.5001 20ZM16.5001 18C16.9167 18 17.2709 17.8542 17.5626 17.5625C17.8542 17.2708 18.0001 16.9167 18.0001 16.5C18.0001 16.0833 17.8542 15.7292 17.5626 15.4375C17.2709 15.1458 16.9167 15 16.5001 15C16.0834 15 15.7292 15.1458 15.4376 15.4375C15.1459 15.7292 15.0001 16.0833 15.0001 16.5C15.0001 16.9167 15.1459 17.2708 15.4376 17.5625C15.7292 17.8542 16.0834 18 16.5001 18ZM4.70006 19.3C4.51673 19.1167 4.42506 18.8833 4.42506 18.6C4.42506 18.3167 4.51673 18.0833 4.70006 17.9L17.9001 4.7C18.0834 4.51667 18.3167 4.425 18.6001 4.425C18.8834 4.425 19.1167 4.51667 19.3001 4.7C19.4834 4.88333 19.5751 5.11667 19.5751 5.4C19.5751 5.68333 19.4834 5.91667 19.3001 6.1L6.10006 19.3C5.91673 19.4833 5.68339 19.575 5.40006 19.575C5.11673 19.575 4.88339 19.4833 4.70006 19.3Z"
                                  fill="#888888"
                                />
                              </g>
                            </svg>
                            Offers
                          </span>
                        </NavLink> */}
                {/* <NavLink
                          className="sidebar_btn flex align_items_center flex_gap_5"
                          to={`/partner/rules/${id}`}
                        >
                          <span className="active_bg_color"></span>
                          <span className="sidebar_btn_icon_text">
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <mask
                                id="mask0_4518_3519"
                                style={{ maskType: "alpha" }}
                                maskUnits="userSpaceOnUse"
                                x="0"
                                y="0"
                                width="24"
                                height="24"
                              >
                                <rect width="24" height="24" fill="#888888" />
                              </mask>
                              <g mask="url(#mask0_4518_3519)">
                                <path
                                  d="M4 21V19H16V21H4ZM9.65 16.15L4 10.5L6.1 8.35L11.8 14L9.65 16.15ZM16 9.8L10.35 4.1L12.5 2L18.15 7.65L16 9.8ZM20.6 20L7.55 6.95L8.95 5.55L22 18.6L20.6 20Z"
                                  fill="#888888"
                                />
                              </g>
                            </svg>
                            Rules
                          </span>
                        </NavLink> */}
                {/* <small className="small_text">GENERAL</small> */}
                <NavLink
                  className="sidebar_btn flex align_items_center flex_gap_5"
                  to={`/vendor-account/${id}`}
                >
                  <span className="active_bg_color"></span>
                  <span className="sidebar_btn_icon_text">
                    {" "}
                    <svg
                      width="20"
                      height="21"
                      viewBox="0 0 20 21"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <mask
                        id="mask0_6855_7787"
                        style={{ maskType: "alpha" }}
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="20"
                        height="21"
                      >
                        <rect y="0.5" width="20" height="20" fill="#888888" />
                      </mask>
                      <g mask="url(#mask0_6855_7787)">
                        <path
                          d="M9.07565 18.4166C8.79148 18.4166 8.54607 18.3223 8.3394 18.1337C8.13259 17.9452 8.00676 17.7131 7.9619 17.4374L7.75836 15.878C7.53516 15.8033 7.30627 15.6987 7.07169 15.5641C6.83725 15.4294 6.62759 15.2851 6.44273 15.1314L4.99877 15.7451C4.73697 15.8605 4.47391 15.8717 4.20961 15.7787C3.94516 15.6858 3.73975 15.517 3.59336 15.2724L2.65419 13.6441C2.5078 13.3995 2.46565 13.1407 2.52773 12.8676C2.58968 12.5947 2.73176 12.3696 2.95398 12.1922L4.20232 11.2547C4.18315 11.1308 4.16954 11.0064 4.16148 10.8814C4.15343 10.7564 4.1494 10.6319 4.1494 10.5078C4.1494 10.3894 4.15343 10.2689 4.16148 10.1466C4.16954 10.0242 4.18315 9.89041 4.20232 9.74513L2.95398 8.80763C2.73176 8.63027 2.591 8.40374 2.53169 8.12804C2.47239 7.85249 2.51593 7.59235 2.66232 7.34763L3.59336 5.74346C3.73975 5.50415 3.94516 5.33672 4.20961 5.24117C4.47391 5.14547 4.73697 5.15534 4.99877 5.27075L6.43461 5.87659C6.63558 5.71742 6.85009 5.57186 7.07815 5.43992C7.30621 5.30797 7.5303 5.20193 7.75044 5.12179L7.9619 3.56242C8.00676 3.28672 8.13259 3.05464 8.3394 2.86617C8.54607 2.67756 8.79148 2.58325 9.07565 2.58325H10.9219C11.2061 2.58325 11.4515 2.67756 11.6581 2.86617C11.865 3.05464 11.9908 3.28672 12.0356 3.56242L12.2392 5.12971C12.4892 5.22054 12.7154 5.32659 12.9177 5.44784C13.1202 5.56909 13.3246 5.712 13.5309 5.87659L15.0069 5.27075C15.2686 5.15534 15.5316 5.14547 15.7961 5.24117C16.0605 5.33672 16.2659 5.50415 16.4121 5.74346L17.3434 7.35575C17.4897 7.60034 17.5319 7.85915 17.4698 8.13221C17.4079 8.40513 17.2658 8.63027 17.0436 8.80763L15.7631 9.76909C15.793 9.90367 15.8093 10.0295 15.8121 10.1466C15.8147 10.2635 15.8161 10.3813 15.8161 10.4999C15.8161 10.6131 15.8134 10.7283 15.8079 10.8453C15.8027 10.9623 15.7835 11.0961 15.7504 11.2468L17.0067 12.1922C17.2289 12.3696 17.3724 12.5947 17.4371 12.8676C17.5017 13.1407 17.4608 13.3995 17.3144 13.6441L16.3704 15.2643C16.2242 15.509 16.0175 15.6778 15.7504 15.7708C15.4834 15.8637 15.2189 15.8524 14.9571 15.737L13.5309 15.1233C13.3246 15.2878 13.1141 15.4334 12.8994 15.5599C12.6847 15.6866 12.4646 15.79 12.2392 15.8701L12.0356 17.4374C11.9908 17.7131 11.865 17.9452 11.6581 18.1337C11.4515 18.3223 11.2061 18.4166 10.9219 18.4166H9.07565ZM9.16544 17.1666H10.8034L11.1029 14.9343C11.5282 14.8232 11.9168 14.6653 12.2688 14.4608C12.6209 14.256 12.9604 13.9929 13.2873 13.6714L15.3577 14.5416L16.1784 13.1249L14.3706 11.7628C14.4401 11.547 14.4873 11.3354 14.5123 11.128C14.5375 10.9208 14.55 10.7114 14.55 10.4999C14.55 10.283 14.5375 10.0736 14.5123 9.87179C14.4873 9.66985 14.4401 9.4636 14.3706 9.25304L16.1942 7.87492L15.3738 6.45825L13.2792 7.34117C13.0003 7.04311 12.6662 6.77978 12.2769 6.55117C11.8875 6.32256 11.4935 6.16068 11.095 6.06554L10.8321 3.83325H9.17836L8.90252 6.05763C8.47739 6.15804 8.08482 6.31186 7.72482 6.51908C7.36468 6.72645 7.02114 6.99353 6.69419 7.32034L4.62377 6.45825L3.80336 7.87492L5.60294 9.21617C5.5335 9.41395 5.48489 9.61964 5.45711 9.83325C5.42933 10.0469 5.41544 10.2717 5.41544 10.5078C5.41544 10.7248 5.42933 10.9374 5.45711 11.1458C5.48489 11.3541 5.53086 11.5598 5.59502 11.7628L3.80336 13.1249L4.62377 14.5416L6.68627 13.6666C7.00252 13.9913 7.34065 14.2573 7.70065 14.4647C8.06079 14.6719 8.45877 14.8311 8.89461 14.9422L9.16544 17.1666ZM10.0084 12.9999C10.7017 12.9999 11.2917 12.7566 11.7784 12.2699C12.265 11.7833 12.5084 11.1933 12.5084 10.4999C12.5084 9.80659 12.265 9.21658 11.7784 8.72992C11.2917 8.24325 10.7017 7.99992 10.0084 7.99992C9.30641 7.99992 8.71426 8.24325 8.2319 8.72992C7.74954 9.21658 7.50836 9.80659 7.50836 10.4999C7.50836 11.1933 7.74954 11.7833 8.2319 12.2699C8.71426 12.7566 9.30641 12.9999 10.0084 12.9999Z"
                          fill="#888888"
                        />
                      </g>
                    </svg>
                    Settings
                  </span>
                </NavLink>

                <NavLink
                  className="sidebar_btn flex align_items_center flex_gap_5"
                  to={`/vendor-account/markup-setting`}
                >
                  <span className="active_bg_color"></span>
                  <span className="sidebar_btn_icon_text">
                    {" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="21"
                      viewBox="0 -960 960 960"
                      width="20"
                      fill="#888888"
                    >
                      <path d="M447-288h64l14-56.31q14-4.69 26.5-11.19Q564-362 575-372l55 16 32-55-41-38.52q2-13.48 3-29.98t-2-29.5l40-38-32-55-54 15q-11-10-24-17t-27-12l-13-56h-65l-12 56q-14 5-27 12t-24 17l-54-16-32 56 41 38q-3 14-3 29.5t3 29.5l-41 39 32 56 55-17q11 9 23.5 16t26.5 12l12 56Zm32.79-120Q450-408 429-429.21t-21-51Q408-510 429.21-531t51-21Q510-552 531-530.79t21 51Q552-450 530.79-429t-51 21ZM216-144q-29.7 0-50.85-21.15Q144-186.3 144-216v-528q0-29.7 21.15-50.85Q186.3-816 216-816h528q29.7 0 50.85 21.15Q816-773.7 816-744v528q0 29.7-21.15 50.85Q773.7-144 744-144H216Zm0-72h528v-528H216v528Zm0-528v528-528Z" />
                    </svg>
                    Markup Settings
                  </span>
                </NavLink>

                <NavLink
                  className="sidebar_btn flex align_items_center flex_gap_5"
                  to={`/vendor/property/help/${id}`}
                >
                  <span className="active_bg_color"></span>
                  <span className="sidebar_btn_icon_text">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="21"
                      viewBox="0 0 20 21"
                      fill="none"
                    >
                      <mask
                        id="mask0_7312_9271"
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="20"
                        height="21"
                      >
                        <rect y="0.5" width="20" height="20" fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_7312_9271)">
                        <path
                          d="M10.0002 18.4163C8.90516 18.4163 7.87592 18.2086 6.91245 17.793C5.94898 17.3775 5.11092 16.8135 4.39828 16.1011C3.68564 15.3888 3.12141 14.5511 2.70557 13.588C2.28988 12.625 2.08203 11.596 2.08203 10.5011C2.08203 9.40613 2.28981 8.3769 2.70536 7.41342C3.12092 6.44995 3.68488 5.6119 4.39724 4.89926C5.1096 4.18662 5.94731 3.62238 6.91036 3.20655C7.87342 2.79085 8.90238 2.58301 9.99724 2.58301C11.0922 2.58301 12.1215 2.79079 13.0849 3.20634C14.0484 3.6219 14.8865 4.18586 15.5991 4.89822C16.3118 5.61058 16.876 6.44829 17.2918 7.41134C17.7075 8.3744 17.9154 9.40335 17.9154 10.4982C17.9154 11.5932 17.7076 12.6225 17.292 13.5859C16.8765 14.5494 16.3125 15.3875 15.6002 16.1001C14.8878 16.8127 14.0501 17.377 13.087 17.7928C12.124 18.2085 11.095 18.4163 10.0002 18.4163ZM7.58203 16.708L8.80641 13.9195C8.28627 13.7359 7.83731 13.4512 7.45953 13.0655C7.08175 12.6797 6.79356 12.2272 6.59495 11.708L3.77432 12.8747C4.09918 13.7636 4.59495 14.5413 5.26161 15.208C5.92828 15.8747 6.70175 16.3747 7.58203 16.708ZM6.59495 9.29134C6.783 8.77217 7.06745 8.32322 7.44828 7.94447C7.82911 7.56572 8.27648 7.28287 8.79036 7.09592L7.6237 4.2753C6.72953 4.61405 5.94911 5.11676 5.28245 5.78342C4.61578 6.45009 4.11307 7.23051 3.77432 8.12467L6.59495 9.29134ZM9.99682 12.8715C10.6552 12.8715 11.2154 12.6411 11.6774 12.1803C12.1395 11.7195 12.3706 11.1599 12.3706 10.5015C12.3706 9.84322 12.1402 9.28301 11.6793 8.82092C11.2185 8.35884 10.6589 8.1278 10.0006 8.1278C9.34224 8.1278 8.78203 8.35822 8.31995 8.81905C7.85786 9.27988 7.62682 9.83947 7.62682 10.4978C7.62682 11.1561 7.85724 11.7163 8.31807 12.1784C8.77891 12.6405 9.33849 12.8715 9.99682 12.8715ZM12.4154 16.708C13.2904 16.3747 14.0577 15.8781 14.7174 15.2184C15.3772 14.5587 15.8737 13.7913 16.207 12.9163L13.4185 11.692C13.2422 12.2059 12.9629 12.6519 12.5804 13.0301C12.1979 13.4083 11.754 13.6994 11.2487 13.9034L12.4154 16.708ZM13.4024 9.24967L16.207 8.08301C15.8737 7.20801 15.3772 6.44065 14.7174 5.78092C14.0577 5.1212 13.2904 4.62467 12.4154 4.29134L11.2487 7.12155C11.7433 7.31377 12.1749 7.5937 12.5435 7.96134C12.9121 8.32884 13.1984 8.75829 13.4024 9.24967Z"
                          fill="#888888"
                        />
                      </g>
                    </svg>
                    Help
                  </span>
                </NavLink>

                <Link
                  className="sidebar_btn flex align_items_center flex_gap_5"
                  onClick={() => setLogOutPopup(true)}
                >
                  <span className="active_bg_color"></span>
                  <span className="sidebar_btn_icon_text">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="21"
                      viewBox="0 0 20 21"
                      fill="none"
                    >
                      <mask
                        id="mask0_6855_7727"
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="20"
                        height="21"
                      >
                        <rect y="0.5" width="20" height="20" fill="#888888" />
                      </mask>
                      <g mask="url(#mask0_6855_7727)">
                        <path
                          d="M10.6182 17.5834C10.441 17.5834 10.2925 17.5236 10.1728 17.4038C10.0532 17.2842 9.99339 17.1358 9.99339 16.9584C9.99339 16.7811 10.0532 16.6326 10.1728 16.513C10.2925 16.3933 10.441 16.3334 10.6182 16.3334H15.5782C15.6423 16.3334 15.7011 16.3067 15.7544 16.2532C15.8079 16.1999 15.8346 16.1411 15.8346 16.077V4.92321C15.8346 4.85904 15.8079 4.80029 15.7544 4.74696C15.7011 4.69348 15.6423 4.66675 15.5782 4.66675H10.6182C10.441 4.66675 10.2925 4.60689 10.1728 4.48716C10.0532 4.36758 9.99339 4.21911 9.99339 4.04175C9.99339 3.86439 10.0532 3.71591 10.1728 3.59633C10.2925 3.47661 10.441 3.41675 10.6182 3.41675H15.5782C15.9992 3.41675 16.3555 3.56258 16.6471 3.85425C16.9388 4.14591 17.0846 4.50223 17.0846 4.92321V16.077C17.0846 16.4979 16.9388 16.8542 16.6471 17.1459C16.3555 17.4376 15.9992 17.5834 15.5782 17.5834H10.6182ZM10.0269 11.1251H3.54297C3.36561 11.1251 3.21714 11.0652 3.09755 10.9455C2.97783 10.8259 2.91797 10.6774 2.91797 10.5001C2.91797 10.3227 2.97783 10.1742 3.09755 10.0547C3.21714 9.93494 3.36561 9.87508 3.54297 9.87508H10.0269L8.42443 8.27258C8.30901 8.15717 8.24998 8.0164 8.24734 7.85029C8.24471 7.68418 8.30373 7.53647 8.42443 7.40716C8.54512 7.27786 8.69151 7.21105 8.86359 7.20675C9.03554 7.20258 9.18616 7.26508 9.31547 7.39425L11.894 9.97279C12.0446 10.1235 12.1198 10.2992 12.1198 10.5001C12.1198 10.7009 12.0446 10.8767 11.894 11.0274L9.31547 13.6059C9.19158 13.7298 9.04443 13.7909 8.87401 13.7892C8.70359 13.7877 8.55373 13.7223 8.42443 13.593C8.30373 13.4637 8.24554 13.3152 8.24984 13.1476C8.25401 12.9798 8.31651 12.8356 8.43734 12.7149L10.0269 11.1251Z"
                          fill="#888888"
                        />
                      </g>
                    </svg>
                    Logout
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      )}

      {!vendorProperty ? (
        <div>
          <div className="flex_align_center justify_content_between HeaderMain-content">
            <div
              className="w-half Header-main flex align_items_center"
              style={{ gap: "20px" }}
            >
              <section className="profile_sec">
                <svg
                  className="profile_spinner"
                  width="50"
                  height="50"
                  viewBox="0 0 60 60"
                >
                  <circle
                    cx="30"
                    cy="30"
                    r="20"
                    stroke="#ddd"
                    strokeWidth="5"
                    fill="transparent"
                  />
                  <circle
                    cx="30"
                    cy="30"
                    r="20"
                    stroke="#009A50"
                    strokeWidth="5"
                    fill="transparent"
                    strokeLinecap="round"
                    strokeDasharray="125.6"
                    strokeDashoffset={125.6 - (125.6 * score) / 100}
                    transform="rotate(0 30 30)"
                  />
                </svg>
                <div>
                  <span>Profile Score</span>
                  <h6>
                    {Math.floor(Number(score))} <span>/ 100</span>
                  </h6>
                </div>
              </section>
            </div>
            <div className="flex justify_content_between align_items_center flex_gap_15">
              {showSelectProperty && (
                <div className="selectedHotel">
                  <ActivePropertySelectBox />
                </div>
              )}
              {isLoggedIn ? (
                <div className="">
                  <VendorAccountDetailDropdown
                    name={name}
                    userType={userType}
                    handleLogout={handleLogout}
                  />
                </div>
              ) : (
                <div className="Mainregister-btn">
                  <LoginBtn />
                </div>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div style={{ padding: "0 10px" }}>
          <div className="flex_align_center justify_content_between HeaderMain-content">
            <div
              className="w-half Header-main flex align_items_center"
              style={{ gap: "20px" }}
            >
              <div style={{ width: "65px" }}>
                <NavLink
                  className="Header-icon"
                  to="/vendor/property/list"
                  exact
                >
                  <img src={logoimg} alt="logo-image" className="logo" />
                </NavLink>
              </div>

              <div className="support_btn cursor_pointer">
                <svg
                  width="16"
                  height="17"
                  viewBox="0 0 16 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <mask
                    id="mask0_2485_129"
                    style={{ maskType: "alpha" }}
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="16"
                    height="17"
                  >
                    <rect y="0.5" width="16" height="16" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_2485_129)">
                    <path
                      d="M8 15.8335V14.5002H12.6667V13.8335H10V8.50016H12.6667V7.8335C12.6667 6.54461 12.2111 5.44461 11.3 4.5335C10.3889 3.62239 9.28889 3.16683 8 3.16683C6.71111 3.16683 5.61111 3.62239 4.7 4.5335C3.78889 5.44461 3.33333 6.54461 3.33333 7.8335V8.50016H6V13.8335H3.33333C2.96667 13.8335 2.65278 13.7029 2.39167 13.4418C2.13056 13.1807 2 12.8668 2 12.5002V7.8335C2 7.01127 2.15833 6.23627 2.475 5.5085C2.79167 4.78072 3.22222 4.14461 3.76667 3.60016C4.31111 3.05572 4.94722 2.62516 5.675 2.3085C6.40278 1.99183 7.17778 1.8335 8 1.8335C8.82222 1.8335 9.59722 1.99183 10.325 2.3085C11.0528 2.62516 11.6889 3.05572 12.2333 3.60016C12.7778 4.14461 13.2083 4.78072 13.525 5.5085C13.8417 6.23627 14 7.01127 14 7.8335V14.5002C14 14.8668 13.8694 15.1807 13.6083 15.4418C13.3472 15.7029 13.0333 15.8335 12.6667 15.8335H8ZM3.33333 12.5002H4.66667V9.8335H3.33333V12.5002ZM11.3333 12.5002H12.6667V9.8335H11.3333V12.5002Z"
                      fill="#333333"
                    />
                  </g>
                </svg>
                Support
                <div className="supportDetails" style={{ right: "auto" }}>
                  <Link className="flex" to="tel:+919805021966">
                    <span className="supportSvg">
                      <svg
                        className="m_0"
                        width="18"
                        height="19"
                        viewBox="0 0 18 19"
                        fill="#FFFFFF"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <mask
                          id="mask0_2263_992"
                          style={{
                            maskType: "alpha",
                            maskUnits: "userSpaceOnUse",
                            x: "0",
                            y: "0",
                            width: "18",
                            height: "19",
                          }}
                        >
                          <rect y="0.5" width="18" height="18" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_2263_992)">
                          <path
                            d="M14.9625 16.25C13.4 16.25 11.8563 15.9094 10.3313 15.2281C8.80625 14.5469 7.41875 13.5813 6.16875 12.3313C4.91875 11.0813 3.95312 9.69375 3.27188 8.16875C2.59063 6.64375 2.25 5.1 2.25 3.5375C2.25 3.3125 2.325 3.125 2.475 2.975C2.625 2.825 2.8125 2.75 3.0375 2.75H6.075C6.25 2.75 6.40625 2.80937 6.54375 2.92812C6.68125 3.04688 6.7625 3.1875 6.7875 3.35L7.275 5.975C7.3 6.175 7.29375 6.34375 7.25625 6.48125C7.21875 6.61875 7.15 6.7375 7.05 6.8375L5.23125 8.675C5.48125 9.1375 5.77812 9.58437 6.12187 10.0156C6.46562 10.4469 6.84375 10.8625 7.25625 11.2625C7.64375 11.65 8.05 12.0094 8.475 12.3406C8.9 12.6719 9.35 12.975 9.825 13.25L11.5875 11.4875C11.7 11.375 11.8469 11.2906 12.0281 11.2344C12.2094 11.1781 12.3875 11.1625 12.5625 11.1875L15.15 11.7125C15.325 11.7625 15.4688 11.8531 15.5812 11.9844C15.6937 12.1156 15.75 12.2625 15.75 12.425V15.4625C15.75 15.6875 15.675 15.875 15.525 16.025C15.375 16.175 15.1875 16.25 14.9625 16.25ZM4.51875 7.25L5.75625 6.0125L5.4375 4.25H3.76875C3.83125 4.7625 3.91875 5.26875 4.03125 5.76875C4.14375 6.26875 4.30625 6.7625 4.51875 7.25ZM11.2313 13.9625C11.7188 14.175 12.2156 14.3438 12.7219 14.4688C13.2281 14.5938 13.7375 14.675 14.25 14.7125V13.0625L12.4875 12.7063L11.2313 13.9625Z"
                            fill="#000"
                          />
                        </g>
                      </svg>
                    </span>
                    <span>
                      <b style={{ fontSize: "12px" }}>Call Support</b>
                      <br />
                      <span style={{ color: "#016937" }}>+91-98050-21966</span>
                    </span>
                  </Link>
                  <Link className="flex" to="mailto:info@mountainmysteries.com">
                    <span className="supportSvg">
                      <svg
                        className="m_0"
                        width="19"
                        height="19"
                        viewBox="0 0 19 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <mask
                          id="mask0_2263_999"
                          style={{
                            maskType: "alpha",
                            maskUnits: "userSpaceOnUse",
                            x: "0",
                            y: "0",
                            width: "18",
                            height: "19",
                          }}
                        >
                          <rect
                            x="0.333374"
                            y="0.5"
                            width="18"
                            height="18"
                            fill="#D9D9D9"
                          />
                        </mask>
                        <g mask="url(#mask0_2263_999)">
                          <path
                            d="M3.33337 15.5C2.92087 15.5 2.56775 15.3531 2.274 15.0594C1.98025 14.7656 1.83337 14.4125 1.83337 14V5C1.83337 4.5875 1.98025 4.23438 2.274 3.94063C2.56775 3.64688 2.92087 3.5 3.33337 3.5H15.3334C15.7459 3.5 16.099 3.64688 16.3927 3.94063C16.6865 4.23438 16.8334 4.5875 16.8334 5V14C16.8334 14.4125 16.6865 14.7656 16.3927 15.0594C16.099 15.3531 15.7459 15.5 15.3334 15.5H3.33337ZM9.33337 10.25L3.33337 6.5V14H15.3334V6.5L9.33337 10.25ZM9.33337 8.75L15.3334 5H3.33337L9.33337 8.75ZM3.33337 6.5V5V14V6.5Z"
                            fill="#000"
                          />
                        </g>
                      </svg>
                    </span>
                    <span>
                      <b style={{ fontSize: "12px" }}>Mail Support</b>
                      <br />
                      <span style={{ color: "#016937" }}>
                        {" "}
                        info@mountainmysteries.com
                      </span>
                    </span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {logOutPopup && (
        <div className="bg_back_drop_overlay">
          <div className="bg-white-div p_0">
            <div style={{ height: "150px" }}>
              {" "}
              <img src={logout} alt="logout image" />
            </div>
            <div className="p_15">
              {" "}
              <h4>Confirm Logout</h4>
              <span className="block mt-5">
                Are you sure you want to logout ?
              </span>
              <div className="mt-10 flex align_items_center flex_gap_5">
                <button
                  className="w-half no_logout_btn"
                  onClick={() => setLogOutPopup(false)}
                >
                  No
                </button>
                <button
                  className="w-half vendor_common_property"
                  onClick={handleLogout}
                >
                  Yes
                </button>
              </div>{" "}
            </div>
          </div>
        </div>
      )}
    </header>
  );
}

export default VendorHeader;
